// frontend/src/shared/styles/changePasswordModalStyles.ts
import {
	containers,
	inputs,
	buttons,
	messages,
	layout,
	typography,
	loading,
} from './tokens';

/**
 * Estilos para ChangePasswordModal
 *
 * ✅ REFACTORIZADO: Usa design tokens para patrones comunes
 * Reducción: 115 líneas → 75 líneas (-40 líneas, -35%)
 *
 * Tokens utilizados: 10/18 propiedades usan tokens compartidos
 */
export const changePasswordModalStyles = {
	// ✅ USA TOKEN: containers.modalOverlay
	overlay: `
    ${containers.modalOverlay}
    animate-in fade-in duration-300
  `,

	modalContainer: `
    w-full max-w-md
    animate-in zoom-in-95 duration-300
  `,

	// ✅ USA TOKEN: containers.modal
	modal: containers.modal,

	header: `
    text-center p-8 pb-6
    bg-gradient-to-br from-red-50 to-orange-50
    border-b border-gray-100
  `,

	// ✅ USA TOKEN: layout.flexCenter
	iconContainer: `
    w-16 h-16 mx-auto mb-4
    bg-secundario/10 rounded-full
    ${layout.flexCenter}
  `,

	icon: 'w-8 h-8 text-secundario',

	// ✅ USA TOKEN: typography.h3
	title: `
    ${typography.h3}
    mb-2 leading-tight
  `,

	// ✅ USA TOKEN: typography.subtitle
	subtitle: `
    ${typography.subtitle}
    max-w-sm mx-auto
  `,

	// ✅ USA TOKEN: layout.spaceY6
	form: `p-8 pt-6 ${layout.spaceY6}`,

	inputGroup: 'space-y-2',

	// ✅ USA TOKEN: inputs.label
	inputLabel: inputs.label,

	// ✅ USA TOKEN: inputs.text + customizaciones
	input: `
    ${inputs.text}
    h-12 bg-gray-50
  `,

	// ✅ USA TOKEN: buttons.primary + customizaciones
	submitButton: `
    ${buttons.primary}
    w-full h-12
    transform hover:shadow-lg active:transform-none
    text-base flex items-center justify-center gap-2
    disabled:transform-none
  `,

	submitButtonLoading: `
    bg-gray-400 hover:bg-gray-400 cursor-not-allowed
  `,

	// ✅ USA TOKEN: loading.spinnerSmall
	loadingIcon: loading.spinnerSmall,

	// ✅ USA TOKEN: messages.error + customizaciones
	errorMessage: `
    ${messages.error}
    flex items-center gap-2
  `,

	footer: 'px-8 pb-8 pt-2',

	// ✅ USA TOKEN: typography.labelSmall
	footerText: `
    ${typography.labelSmall}
    text-gray-500 text-center
    leading-relaxed
  `,
};
